/** Pavilion compact shell — matches Figma / transparent native window cutouts */
/** Inset from work-area / parent rect right-bottom; keep in sync with host-electron PAVILION_WORK_AREA_MARGIN. */
export const PAVILION_WORK_AREA_MARGIN_PX = 12;

export const PAVILION_SHELL_RADIUS = 'rounded-[12px]';
export const PAVILION_SHELL_BORDER = 'border-[3px] border-[#3D2A69]';
export const PAVILION_SHELL_GRADIENT = 'bg-[#0b0618]';
